module.exports = __webpack_public_path__ + "static/media/logo.7364b531.png";